import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../../../ui_kit/button/Button';

function SubmitReviewFormButton(props) {
  const {
    loading, customFullButtonStyle, isCampaign,
  } = props;

  const submitRef = useRef(null);

  const applyCustomLoadingOrNot = () => {
    if (!isCampaign) { return ''; }
    if (loading) { return 'loading'; }
    return '';
  };

  const onClick = () => {
    submitRef.current.click();
  };

  return (
    <>
      <style>{customFullButtonStyle}</style>
      <button ref={submitRef} type="submit" style={{ display: 'none' }}>submit</button>
      <Button
        className={`custom-button ${applyCustomLoadingOrNot()}`}
        text="Submit"
        size="small"
        color="blue"
        loading={loading}
        onClickHandler={onClick}
      />
    </>
  );
}

SubmitReviewFormButton.propTypes = {
  loading: PropTypes.bool,
  customFullButtonStyle: PropTypes.string,
  isCampaign: PropTypes.bool.isRequired,
};

export default connect()(SubmitReviewFormButton);
